import { Stethoscope } from "lucide-react";
import { CatalogPage } from "@/components/common/CatalogPage";
import { specializationsApi } from "@/lib/api";
import type { Specialization } from "@/lib/api/types";

/** Doctor specializations shown in the app (English + Swahili). */
export default function SpecializationsPage() {
  return (
    <CatalogPage<Specialization>
      queryKey="specializations"
      title="Specializations"
      subtitle={(n) => `${n} medical specializations doctors can choose and patients can filter by.`}
      icon={Stethoscope}
      noun="specialization"
      searchPlaceholder="Search specializations…"
      source={{
        kind: "list",
        fetch: specializationsApi.list,
        searchText: (s) => `${s.name} ${s.nameSwahili} ${s.category ?? ""}`,
      }}
      itemLabel={(s) => s.name}
      columns={[
        { header: "Name", render: (s) => <span className="font-semibold">{s.name}</span> },
        { header: "Swahili", render: (s) => s.nameSwahili },
        { header: "Category", render: (s) => s.category ?? "—" },
      ]}
      fields={[
        { key: "name", label: "Name (English)", required: true, half: true, placeholder: "Cardiology" },
        { key: "nameSwahili", label: "Name (Swahili)", required: true, half: true, placeholder: "Magonjwa ya moyo" },
        { key: "category", label: "Category", placeholder: "e.g. Internal medicine" },
        { key: "description", label: "Description (English)", type: "textarea" },
        { key: "descriptionSwahili", label: "Description (Swahili)", type: "textarea" },
        { key: "iconUrl", label: "Icon URL", placeholder: "https://…" },
      ]}
      create={specializationsApi.create}
      update={specializationsApi.update}
      // No delete endpoint: doctors reference specializations by name.
    />
  );
}
